<app-header></app-header>
<div class="my-profile-container container">
    <h2 class="text-center title">My Profile</h2>

    <div class="page">
        <div class="page-content">
          <div class="profile-header">
            <div class="profile-image">
              <img src="assets/voyjaleas/logo/voyJaleasImagotipo.PNG" class="bordered-image" alt=""> <!-- https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/e0bb451d-1ffa-4c08-8e94-952111bdc100/public -->
              <!-- <div class="profile-online bg-color-green"></div> -->
            </div>
    
            <!-- NAME / USERNAME -->
            <div *ngIf="getProfileData().name && getProfileData().lastname" class="profile-name">{{getProfileData().name}} {{getProfileData().lastname}} {{getProfileData().lastname2}}</div>
            <div *ngIf="!getProfileData().name" class="profile-name">{{getSessionData().username}}</div>
            <div *ngIf="isLoading() && (!getProfileData() || !getProfileData().name)" class="profile-name center">
              <mat-spinner [diameter]="30"></mat-spinner>
            </div>
            <div class="profile-subtitle">{{getProfileData().career}}</div>
          </div>

          <div class="col-md-8">
            <ul class="list-group">
              <li class="list-group-item"><strong>Name:</strong> {{ clientDetails.name }} {{ clientDetails.lastname }} {{ clientDetails.lastname2 }} <i class="fas fa-edit" (click)="editField('name')"></i></li>
              <li class="list-group-item"><strong>Birthday:</strong> {{ clientDetails.birthday | date }} <i class="fas fa-edit" (click)="editField('birthday')"></i></li>
              <li class="list-group-item"><strong>Age:</strong> {{ clientDetails.age }} <i class="fas fa-edit" (click)="editField('age')"></i></li>
              <li class="list-group-item"><strong>Email:</strong> {{ clientDetails.email }} <i class="fas fa-edit" (click)="editField('email')"></i></li>
              <li class="list-group-item"><strong>Phone:</strong> {{ clientDetails.phone1 }}, {{ clientDetails.phone2 }} <i class="fas fa-edit" (click)="editField('phone')"></i></li>
              <li class="list-group-item"><strong>Instagram:</strong> <a [href]="clientDetails.instagram" target="_blank">{{ clientDetails.instagram }}</a> <i class="fas fa-edit" (click)="editField('instagram')"></i></li>
              <li class="list-group-item"><strong>Address:</strong> {{ clientDetails.address }} <i class="fas fa-edit" (click)="editField('address')"></i></li>
              <li class="list-group-item"><strong>Current Studies:</strong> {{ clientDetails.currentStudies }} <i class="fas fa-edit" (click)="editField('currentStudies')"></i></li>
              <li class="list-group-item"><strong>University:</strong> {{ clientDetails.university }} <i class="fas fa-edit" (click)="editField('university')"></i></li>
              <li class="list-group-item"><strong>Payments:</strong> {{ clientDetails.payments }} <i class="fas fa-edit" (click)="editField('payments')"></i></li>
              <li class="list-group-item"><strong>Apartment Filters:</strong> {{ clientDetails.apartmentFilters }} <i class="fas fa-edit" (click)="editField('apartmentFilters')"></i></li>
              <li class="list-group-item"><strong>Additional Interests:</strong> {{ clientDetails.additionalInterests }} <i class="fas fa-edit" (click)="editField('additionalInterests')"></i></li>
            </ul>
          </div>




          <div class="profile-buttons">
            <a href="" class="link contact-button" [matMenuTriggerFor]="menuOthers">
              <i class="icon f7-icons arrow-back">logo_instagram</i>
            </a>
    
            <a href="#" class="link contact-button" [matMenuTriggerFor]="menuOthers">
              <i class="icon f7-icons arrow-back">envelope</i>
            </a>
            <a href="#" [matMenuTriggerFor]="menu" class="button button-fill button-round color-dark button-icon-left author-follow">
              <i class="icon f7-icons">plus</i>
              Información
            </a>
          <mat-menu #menu="matMenu">
            <button mat-menu-item *ngIf="getProfileData().phone1"><i class="fas fa-mobile-alt"></i>{{getProfileData().phone1}}</button>
            <button mat-menu-item *ngIf="getProfileData().phone2"><i class="fas fa-mobile-alt"></i>{{getProfileData().phone2}}</button>
            <button mat-menu-item *ngIf="!isDateEmpty(getProfileData().startLessons)">Inicio Leccciones:{{getProfileData().startLessons}}</button>
            <button mat-menu-item *ngIf="getProfileData().stayWorking == 'yes'">Si le gustaría quedarse trabajando{{getProfileData().stayWorking}}</button>
            <button mat-menu-item *ngIf="getProfileData().uePassport== 'no'">No tiene pasaporte de la UE</button>
            <button mat-menu-item *ngIf="getProfileData().uePassport== 'yes'">Tiene pasaporte de la UE</button>
            <button mat-menu-item *ngIf="getProfileData().apartmentBudget>0">Presupuesto máximo apto: {{getProfileData().apartmentBudget}} euros.</button>
    
            <mat-menu #menuOthers="matMenu">
              <button mat-menu-item  *ngIf="getProfileData().instagram">{{getProfileData().instagram}}</button>
              <button mat-menu-item  *ngIf="!getProfileData().instagram">No tenemos tu instagram todavía.</button>
              <button mat-menu-item *ngIf="getProfileData().email">{{getProfileData().email}}</button>
              <button mat-menu-item *ngIf="!getProfileData().email">No tenemos tu correo electrónico todavía.</button>
            </mat-menu>
    
    
    <!-- additionalInterests
    age
    apartmentBathroom
    apartmentBudget
    apartmentFilters
    apartmentType
    birthday
    country
    currentStudies
    dateFrom
    dateTo
    destination
    driveUrl
    firstContactDate
    future
    goal
    hasStudentVisa
    how
    imageUrl
    lastContactDate
    lastname2
    payment
    phone2
    present
    startLessons
    studyConfirmation
    studyDescription
    studyHistory
    tuitionPaid
    usVisa
    validPassport
     -->
    
          </mat-menu>
          </div>
          <div class="grid grid-cols-3 grid-gap profile-stats">
            <!-- ESTUDIOS A REALIZAR -->
            <div class="profile-stat">
              <div class="center"><mat-progress-spinner  *ngIf="isLoading()" [diameter]="20"></mat-progress-spinner></div>
              <div *ngIf="!isLoading() && getProfileData().studyType" class="profile-stat-number">{{getProfileData().studyType}}</div>
              <div *ngIf="!isLoading() && getProfileData().studyType" class="profile-stat-title">Estudios</div>
                <!-- IF NO STUDY TYPE FILL WITH STUDY SEARCH -->
            <div *ngIf="!isLoading() && !getProfileData().studyType" class="profile-stat-number">{{toYesNo(getProfileData().studySearch)}}</div>
            <div *ngIf="!isLoading() && !getProfileData().studyType" class="profile-stat-title">Ha comenzado búsqueda</div>
    
            </div>
    
          
            <!-- PROFESION -->
            <div class="profile-stat">
              <span class="center"><mat-spinner  *ngIf="isLoading()" [diameter]="20" class="button-spinner center"></mat-spinner></span>
              <div class="profile-stat-number" *ngIf="!isLoading() && getProfileData().career">{{getUniversityText(getProfileData().career)}}</div>
              <div class="profile-stat-title">Profesión</div>
            </div>
            
            <!-- UNIVERSIDAD -->
            <div class="profile-stat" *ngIf="getProfileData().university">
              <span class="center"><mat-spinner  *ngIf="isLoading()" [diameter]="20" class="button-spinner center"></mat-spinner></span>
              <div class="profile-stat-number" *ngIf="!isLoading() && getProfileData().university">{{getProfileData().university}}</div>
              <div class="profile-stat-title">Universidad</div>
            </div>
    
            <!-- PAÍS OORIGEN -->
            <div class="profile-stat" *ngIf="!getProfileData().university">
              <span class="center"><mat-spinner  *ngIf="isLoading()" [diameter]="20" class="button-spinner center"></mat-spinner></span>
              <div class="profile-stat-number" *ngIf="!isLoading() && getProfileData().country">{{getProfileData().country}}</div>
              <div class="profile-stat-title">País origen</div>
            </div>
            
          </div>
    
          <!-- Photo by <a href="https://unsplash.com/@alevisionco?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Alev Takil</a> on <a href="https://unsplash.com/photos/brown-and-black-concrete-buildings-at-daytime-x2Or94kjaqo?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> -->
          
          <!-- Barcelona
          Photo by <a href="https://unsplash.com/@nikkodime?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Nikolay Dimitrov</a> on <a href="https://unsplash.com/photos/aerial-photo-of-building-jS_8S_jQtSk?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a>
           -->
           <!-- Valencia
           Photo by <a href="https://unsplash.com/@franckcharles_?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Franck CHARLES</a> on <a href="https://unsplash.com/photos/coconut-palm-trees-near-building-GvFC6fibHsM?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a>
            -->
            <!-- Other
            Photo by <a href="https://unsplash.com/@claybanks?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Clay Banks</a> on <a href="https://unsplash.com/photos/silhouette-of-airplane-flying-over-the-people-during-sunset-O5hfuVWgsS8?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a>
            -->
          <div class="movie-header">
            <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/8a202a90-1617-4020-9032-59a5a9d00600/public" *ngIf="getProfileData().destination  == 'Madrid'" alt="" class="movie-cover">
            <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/1e0508df-5037-4014-4f4b-b8327b57c400/public" *ngIf="getProfileData().destination  == 'Barcelona'" alt="" class="movie-cover">
            <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/ad256667-e9ce-4dd3-8581-a2b2864fd500/public" *ngIf="getProfileData().destination  == 'Valencia'" alt="" class="movie-cover">
            <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/85a0beb6-1ece-4f37-c45a-8c75364afa00/public" *ngIf="!getProfileData().destination || (getProfileData().destination  != 'Valencia' && getProfileData().destination != 'Madrid' && getProfileData().destination != 'Barcelona') " alt="" class="movie-cover">
            <div class="movie-infos">
    
              <!-- FIRST CARD -->
              <!-- DESTINATION OR UNIVERSITY -->
              <div class="movie-block" >
                <i *ngIf="getProfileData().destination" class="fa-solid fa-map-location-dot"></i>
                <div *ngIf="getProfileData().destination" class="movie-block-name">Destino</div>
                <mat-spinner *ngIf="isLoading() && (!getProfileData() || !getProfileData().destination)" [diameter]="20"></mat-spinner>
                <div class="movie-block-text" *ngIf="!isLoading() && getProfileData().destination">{{getProfileData().destination}}</div>
    
                <i class="fa-solid fa-building-columns" *ngIf="!getProfileData().destination && getProfileData().university"></i>
                <div *ngIf="!getProfileData().destination && getProfileData().university" class="movie-block-name">Centro estudios</div>
                <div *ngIf="!isLoading() && !getProfileData().destination && getProfileData().university" class="movie-block-text">{{getProfileData().university}}</div>
              </div>
    
              <!-- SECOND CARD -->
              <div class="movie-block" *ngIf="!isDateEmpty(getProfileData().dateFrom)  && !isDateEmpty(getProfileData().dateTo)">
                <i class="fas fa-calendar-alt"></i>
                <div class="movie-block-name">Duración</div>
                <div class="movie-block-text">{{getTotalDuration()}}</div>
              </div>
    
              <div class="movie-block" *ngIf="isDateEmpty(getProfileData().dateFrom)  || isDateEmpty(getProfileData().dateTo)">
                <i class="fas fa-calendar-alt"></i>
                <div class="movie-block-name">Duración</div>
                <div class="movie-block-text">Por definir</div>
              </div>
    
              <!-- TERCERA CARD -->
              <div class="movie-block">
    
                <!-- LLEGADA A ESPAÑA -->
                <i class="fas fa-plane-arrival" *ngIf="!isDateEmpty(getProfileData().dateFrom)"></i>
                <div class="movie-block-name" *ngIf="!isDateEmpty(getProfileData().dateFrom)">Llegada</div>
                <div class="movie-block-text" *ngIf="!isLoading() && !isDateEmpty(getProfileData().dateFrom)">
                  <app-date-render [date]="getProfileData().dateFrom" [format]="'short'"></app-date-render>
                </div>
              
                <!-- INICIO LECCIONES -->
                <i class="fas fa-graduation-cap" *ngIf="!isLoading() && isDateEmpty(getProfileData().dateFrom)"></i>
                <div class="movie-block-name" *ngIf="!isLoading() && isDateEmpty(getProfileData().dateFrom)">Inicio Lecciones</div>
                <div class="movie-block-text" *ngIf="!isLoading() && !isDateEmpty(getProfileData().startLessons) && isDateEmpty(getProfileData().dateFrom)">{{getProfileData().startLessons}}</div>
                <div class="movie-block-text" *ngIf="!isLoading() && isDateEmpty(getProfileData().startLessons) && isDateEmpty(getProfileData().dateFrom)">Por definir</div>
    
                <mat-spinner *ngIf="(isLoading() && !getProfileData().dateFrom) || (isLoading() && !getProfileData().startLessons)" [diameter]="20"></mat-spinner>
    
              </div>
            </div>
          </div>
    
          <a href="javascript: void(0)" class="link link-banner dark-theme-green">
            <i class="fas fa-flag-checkered"></i>
            <div class="link-banner-text">
              <div class="link-banner-title">Objetivo</div> <!-- <i class="fa-regular fa-pen-to-square" *ngIf="!getProfileData().goal"></i> -->
              
              <div class="link-banner-subtitle">
                {{getProfileData().goal}}
              </div>
            </div>
          </a>
          
    
          <!-- TIENE PASAPORTE EUROPEO -->
          <a href="javascript: void(0)" class="link link-banner" *ngIf="getProfileData().uePassport=='yes'">
            <i class="fas fa-passport"></i>
            <div class="link-banner-text">
              <div class="link-banner-title">Pasaporte Europeo</div>
              <div class="link-banner-subtitle">Cuenta con pasaporte Europeo</div>
            </div>
          </a>
    
          <!-- HA VISITADO EUROPA ANTES -->
          <a href="javascript: void(0)" class="link link-banner dark-theme-green" *ngIf="getProfileData().atEurope =='yes' && getProfileData().visitedCountries">
            <i class="fas fa-location"></i>
            <div class="link-banner-text">
              <div class="link-banner-title">Países/ciudades que ha visitado de Europa</div> <!-- <i class="fa-regular fa-pen-to-square" *ngIf="!getProfileData().goal"></i> -->
              <div class="link-banner-subtitle">
                {{getProfileData().visitedCountries}}
              </div>
            </div>
          </a>
    
          <!-- DIRECCION -->
          <a href="javascript: void(0)" class="link link-banner dark-theme-green" *ngIf="getProfileData().address">
            <i class="fas fa-location"></i>
            <div class="link-banner-text">
              <div class="link-banner-title">Dirección</div> <!-- <i class="fa-regular fa-pen-to-square" *ngIf="!getProfileData().goal"></i> -->
              <div class="link-banner-subtitle">
                {{getProfileData().address}}
              </div>
            </div>
          </a>
          
    
          <!-- PLAN -->
          <h1 *ngIf="getProfileData().present">Inicio</h1>
          <mat-progress-spinner *ngIf="!getProfileData().present"></mat-progress-spinner>
          <app-smart-paragraph [text]="getProfileData().present" [limit]="200"></app-smart-paragraph>
    
          <!-- PLAN -->
          <h1 *ngIf="getProfileData().future">Plan</h1>
          <app-smart-paragraph [text]="getProfileData().future" [limit]="250"></app-smart-paragraph>
    
          <!-- NOTES -->
          <h1 *ngIf="getProfileData().comments">Notas</h1>
          <app-smart-paragraph [text]="getProfileData().comments" [limit]="200"></app-smart-paragraph>
          
          <div class="section-title">Ayuda</div>
          <div class="medium-gray-title">Contactos para solicitar asistencia.</div>
          <div class="list detailed-list list-dividers full-width author-list">
            <ul>
              <li>
                <div class="item-content">
                  <div class="item-media"><img src="assets/voyjaleas/logo/voyJaleasImagotipo.PNG" class="bordered-image" alt=""></div>
                  <div class="item-inner">
                    <div class="item-title">
                      <div class="item-name">Sebastián Jiménez </div>
                      <div class="item-footer">CEO</div><div class="item-footer">sebtec12@gmail.com</div>
                    </div>
                    <div class="item-after"> 
                      <!-- <div class="button button-fill button-round color-dark button-icon-left author-follow">
                        <i class="icon f7-icons">plus</i>
                        Follow
                      </div> -->
                    </div>
                  </div>
                </div>
              </li>
              <!-- <li>
                <div class="item-content">
                  <div class="item-media"><img src="assets/voyjaleas/logo/voyJaleasImagotipo.PNG" class="bordered-image" alt=""></div>
                  <div class="item-inner">
                    <div class="item-title">
                      <div class="item-name">SSSSSS</div>
                      <div class="item-footer">COO</div><div class="item-footer">@mail</div>
                    </div>
                    <div class="item-after">
                      <div class="button button-fill button-round color-dark button-icon-left author-follow">
                        <i class="icon f7-icons">plus</i>
                        Follow
                      </div>
                    </div>
                  </div>
                </div>
              </li> -->
              <li>
                <div class="item-content">
                  <div class="item-media"><img src="assets/voyjaleas/logo/voyJaleasImagotipo.PNG" class="bordered-image" alt=""></div>
                  <div class="item-inner">
                    <div class="item-title">
                      <div class="item-name">Equipo de VoyJaleas</div>
                      <div class="item-footer">Atención al cliente</div>
                      <div class="item-footer">{{getSupportEmail()}}</div>
                    </div>
                    <div class="item-after">
                      <!-- <div class="button button-fill button-round color-dark button-icon-left author-follow">
                        <i class="icon f7-icons">plus</i>
                        Follow
                      </div> -->
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
    
          <!-- PROMO -->
          <div class="medium-gray-title">Light With Image</div>
          <a href="#" class="ticket">
            <div class="ticket-infos">
              <div class="ticket-text color-primary">Special Offer</div>
              <div class="ticket-discount">-50%</div>
              <div class="ticket-description color-primary">Off all our store!</div>
            </div>
            <div class="ticket-image"><img src="assets/img/images/ticket-clothes.png" alt=""></div>
          </a>
    
          <!-- ONBOARDING -->
          <h2>Onboarding</h2>
          <iframe width="560" height="315" src="https://www.youtube.com/embed/5jY1ecibLYo?controls=0"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen></iframe>
          <h2 class="list-title">Distribution</h2>
          <div class="list simple-list list-outline list-dividers full-width movie-distribution">
            <ul>
              <li>
                <div class="item-inner">
                  <div class="item-title">Director</div>
                  <div class="item-after">Ava Martinez</div>
                </div>
              </li>
              <li>
                <div class="item-inner">
                  <div class="item-title">Producer</div>
                  <div class="item-after">Ethan Bishop</div>
                </div>
              </li>
            </ul>
          </div>
    
          <!-- PAQUETES DISPONIBLES -->
          <app-pricing-plans [packages]="packages"></app-pricing-plans>
        </div>
      </div>
  
    <!-- Client Details Section -->

  
    <!-- Follow Up Section -->
    <div class="section follow-up">
      <h3>Follow Up</h3>
      <table class="table table-hover shadow-sm">
        <thead class="thead-dark">
          <tr>
            <th>Status</th>
            <th>Last Updated At</th>
            <th>Last Interaction Date</th>
            <th>Notes</th>
            <th>Progress</th>
            <th>Assignee</th>
            <th>Service Type</th>
            <th>Origin</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let followUp of followUpData">
            <td>{{ followUp.status }}</td>
            <td>{{ followUp.lastUpdatedAt | date }}</td>
            <td>{{ followUp.lastInteractionDate | date }}</td>
            <td>{{ followUp.notes }}</td>
            <td>{{ followUp.progress }}</td>
            <td>{{ followUp.assignee }}</td>
            <td>{{ followUp.serviceType }}</td>
            <td>{{ followUp.origin }}</td>
            <td><i class="fas fa-edit" (click)="editFollowUp(followUp)"></i></td>
          </tr>
        </tbody>
      </table>
    </div>
  
    <!-- Study Details Section -->
    <div class="section study-details">
      <h3>Study Details</h3>
      <ul class="list-group">
        <li class="list-group-item"><strong>Study History:</strong> {{ clientDetails.studyHistory }} <i class="fas fa-edit" (click)="editField('studyHistory')"></i></li>
        <li class="list-group-item"><strong>Study Search:</strong> {{ clientDetails.studySearch }} <i class="fas fa-edit" (click)="editField('studySearch')"></i></li>
        <li class="list-group-item"><strong>Study Description:</strong> {{ clientDetails.studyDescription }} <i class="fas fa-edit" (click)="editField('studyDescription')"></i></li>
        <li class="list-group-item"><strong>Study Type:</strong> {{ clientDetails.studyType }} <i class="fas fa-edit" (click)="editField('studyType')"></i></li>
        <li class="list-group-item"><strong>Study Confirmation:</strong> {{ clientDetails.studyConfirmation }} <i class="fas fa-edit" (click)="editField('studyConfirmation')"></i></li>
      </ul>
    </div>
  
    <!-- Visa Information Section -->
    <div class="section visa-info">
      <h3>Visa Information</h3>
      <ul class="list-group">
        <li class="list-group-item"><strong>Has Student Visa:</strong> {{ clientDetails.hasStudentVisa }} <i class="fas fa-edit" (click)="editField('hasStudentVisa')"></i></li>
        <li class="list-group-item"><strong>US Visa:</strong> {{ clientDetails.usVisa }} <i class="fas fa-edit" (click)="editField('usVisa')"></i></li>
        <li class="list-group-item"><strong>UE Passport:</strong> {{ clientDetails.uePassport }} <i class="fas fa-edit" (click)="editField('uePassport')"></i></li>
        <li class="list-group-item"><strong>Valid Passport:</strong> {{ clientDetails.validPassport }} <i class="fas fa-edit" (click)="editField('validPassport')"></i></li>
      </ul>
    </div>
  
    <!-- Contact Information Section -->
    <div class="section contact-info">
      <h3>Contact Information</h3>
      <ul class="list-group">
        <li class="list-group-item"><strong>First Contact Date:</strong> {{ clientDetails.firstContactDate | date }} <i class="fas fa-edit" (click)="editField('firstContactDate')"></i></li>
        <li class="list-group-item"><strong>Last Contact Date:</strong> {{ clientDetails.lastContactDate | date }} <i class="fas fa-edit" (click)="editField('lastContactDate')"></i></li>
        <li class="list-group-item"><strong>Comments:</strong> {{ clientDetails.comments }} <i class="fas fa-edit" (click)="editField('comments')"></i></li>
      </ul>
    </div>
  
    <!-- Apartment Preferences Section -->
    <div class="section apartment-preferences">
      <h3>Apartment Preferences</h3>
      <ul class="list-group">
        <li class="list-group-item"><strong>Apartment Type:</strong> {{ clientDetails.apartmentType }} <i class="fas fa-edit" (click)="editField('apartmentType')"></i></li>
        <li class="list-group-item"><strong>Apartment Budget:</strong> {{ clientDetails.apartmentBudget }} <i class="fas fa-edit" (click)="editField('apartmentBudget')"></i></li>
        <li class="list-group-item"><strong>Apartment Bathroom:</strong> {{ clientDetails.apartmentBathroom }} <i class="fas fa-edit" (click)="editField('apartmentBathroom')"></i></li>
        <li class="list-group-item"><strong>Stay Working:</strong> {{ clientDetails.stayWorking }} <i class="fas fa-edit" (click)="editField('stayWorking')"></i></li>
      </ul>
    </div>
  
    <!-- Location Information Section -->
    <div class="section location-info">
      <h3>Location Information</h3>
      <ul class="list-group">
        <li class="list-group-item"><strong>Country:</strong> {{ clientDetails.country }} <i class="fas fa-edit" (click)="editField('country')"></i></li>
        <li class="list-group-item"><strong>At Europe:</strong> {{ clientDetails.atEurope }} <i class="fas fa-edit" (click)="editField('atEurope')"></i></li>
        <li class="list-group-item"><strong>Visited Countries:</strong> {{ clientDetails.visitedCountries }} <i class="fas fa-edit" (click)="editField('visitedCountries')"></i></li>
        <li class="list-group-item"><strong>Destination:</strong> {{ clientDetails.destination }} <i class="fas fa-edit" (click)="editField('destination')"></i></li>
      </ul>
    </div>
  </div>
  
<app-footer></app-footer>